import { isNil as _isNil } from 'lodash';
import { isConnectionUpload, isPlaybookUpload } from './UPLOAD_TYPE';

// Assembles the integration payload sent to the validate mutation. Shared by the
// initial (auto-detected) and override validation paths so both are identical.
export default function buildValidatePayload({ result, uploadType, playbookState, integration, clusterId }) {
  const connectionType = Object.keys(playbookState.connectionJSON)[0];
  const playbook = ensureVersionIsString(isPlaybookUpload(uploadType) ? result : playbookState.playbook);

  return {
    clusterId,
    integration: {
      ...(isConnectionUpload(uploadType) ? { [connectionType]: { ...result } } : playbookState.connectionJSON),
      integrationName: integration.starterkitId,
      transformStages: [
        {
          data: {
            playbook,
          },
          desc: integration.starterkitId,
          name: `integration for ${integration.starterkitId}`,
        },
      ],
    },
  };
}

function ensureVersionIsString(obj) {
  if (_isNil(obj?.version)) {
    return obj;
  }
  return { ...obj, version: String(obj.version) };
}
